import withActDetail from "../withActDetail";
import ActTicksForm from "./ActTicksForm";
import ActTicksPDFGenerator from "./ActTicksPDFGenerator";

const actFormKazakhName = 'Кенелерден сынаманы іріктеу АКТІСІ'
const actFormName = 'АКТ отбора клещей'
const actFormNumber = '011'
const actName = 'ActTicks'

export default withActDetail(ActTicksForm, ActTicksPDFGenerator, actFormKazakhName, actFormName, actFormNumber, actName)